import ChipClickable from './ChipClickable';

export {
  ChipClickable
}



// WEBPACK FOOTER //
// ./src/components/Chips/index.js